import React from 'react';
import { formatCnpjCpfMask } from '../utils/filtroHelpers';
import './RichSelectOption.css';

/** Template de item/valor para Dropdown (nome, fantasia, CNPJ). */
export function RichSelectOption({ option, selected = false }) {
  if (!option) return null;
  // "Todas" / placeholder sem dados ricos — value null E sem CNPJ/razão
  const soLabel =
    (option.value === null || option.value === undefined) &&
    !option.cnpjcpf &&
    !option.razao &&
    !option.isMatriz;
  if (soLabel) {
    return <span className={`rich-opt ${selected ? 'rich-opt-selected' : ''}`}>{option.label}</span>;
  }
  const razao = option.razao || option.label || '';
  const fantasia = option.fantasia || '';
  const cnpj = option.cnpjcpf ? formatCnpjCpfMask(option.cnpjcpf) : '';
  return (
    <div className={`rich-opt ${selected ? 'rich-opt-selected' : ''}`}>
      <div className="rich-opt-nome">{razao || option.label}</div>
      {(fantasia || cnpj) && (
        <div className="rich-opt-meta">
          {fantasia ? <span>{fantasia}</span> : null}
          {fantasia && cnpj ? <span className="rich-opt-sep">·</span> : null}
          {cnpj ? <span>{cnpj}</span> : null}
        </div>
      )}
    </div>
  );
}

export function richItemTemplate(option) {
  return <RichSelectOption option={option} />;
}

/** Valor no trigger: uma linha (nome · CNPJ) para não estourar a altura do campo. */
export function richValueTemplate(option, props) {
  if (!option) {
    return <span className="rich-opt-placeholder">{props?.placeholder || 'Selecione'}</span>;
  }
  const soLabel =
    (option.value === null || option.value === undefined) &&
    !option.cnpjcpf &&
    !option.razao &&
    !option.isMatriz;
  if (soLabel) {
    return <span className="rich-opt rich-opt-selected">{option.label}</span>;
  }
  const nome = option.fantasia || option.razao || option.label || '';
  const cnpj = option.cnpjcpf ? formatCnpjCpfMask(option.cnpjcpf) : '';
  return (
    <span className="rich-opt rich-opt-selected rich-opt-value-line">
      <span className="rich-opt-nome">{nome}</span>
      {cnpj ? <span className="rich-opt-meta-inline">{cnpj}</span> : null}
    </span>
  );
}
